import { Navigate, Outlet } from 'react-router-dom';
import { useFeatureFlag, type FeatureFlag } from '../lib/featureFlags';

interface FeatureRouteProps {
  flag: FeatureFlag;
  redirectTo?: string;
}

// Route-level feature flag guard. Renders the nested <Outlet /> when the flag
// is on, otherwise redirects so deep-link bookmarks fail closed.
export const FeatureRoute = ({ flag, redirectTo = '/dashboard' }: FeatureRouteProps) => {
  const enabled = useFeatureFlag(flag);

  if (!enabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default FeatureRoute;
